/*
  initial component generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { FunctionComponent, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { BODYPART, BodyPartDictionary } from "../../models/bodypart";
import { HUMAN_FEMALE_PATH, preloadGLTFAsset } from "./3d-models";

type GLTFResult = GLTF & {
  nodes: {
    Female_Body_Final_Transparent_1: THREE.Mesh;
    Female_Body_Final_1: THREE.Mesh;
  };
  materials: {
    Human_TransparentTexture: THREE.MeshStandardMaterial;
    Human_OpaqueTexture: THREE.MeshStandardMaterial;
  };
};

interface IHumanFemale {
  activeBodyPart?: BODYPART;
  bodyPartColor?: string;
  humanRef: React.MutableRefObject<THREE.Group | undefined>;
}

export const HumanFemale: FunctionComponent<IHumanFemale> = (props) => {
  const { activeBodyPart, bodyPartColor, humanRef } = props;
  const { nodes, materials } = useGLTF(HUMAN_FEMALE_PATH) as GLTFResult;

  const material = useMemo(() => {
    if (activeBodyPart) {
      return materials.Human_TransparentTexture;
    }
    return materials.Human_OpaqueTexture;
  }, [activeBodyPart, materials]);

  const BodyPartComponent = useMemo(() => (activeBodyPart ? BodyPartDictionary[activeBodyPart] : undefined), [
    activeBodyPart,
  ]);

  return (
    <group ref={humanRef} dispose={null}>
      <group rotation={[0, 0, 0]} scale={[0.07, 0.07, 0.07]} position={[0, -6.5, 0]}>
        <mesh material={material} geometry={nodes.Female_Body_Final_1.geometry} castShadow />
        {BodyPartComponent && <BodyPartComponent color={bodyPartColor} />}
      </group>
    </group>
  );
};

preloadGLTFAsset(HUMAN_FEMALE_PATH);
